/* eslint-disable @typescript-eslint/no-explicit-any */
export enum EngineTypeSR {
    Gasoline = <any>'Benzin',
    Diesel = <any>'Dizel',
    LNG = <any>'TPG',
    LPG = <any>'TNG',
    CNG = <any>'KPG',
    Electric = <any>'Struja',
}
